import SlideFrame from "./_SlideFrame";

export default function SlideLendingScaling() {
  const data = [
    { label: "Fintech & embedded finance", value: "growing", note: "New products launching monthly" },
    { label: "Credit unions modernizing", value: "expanding", note: "Seeking operational support" },
    { label: "Bank partnership programs", value: "scaling", note: "White-label portfolios" },
    { label: "Traditional servicing infrastructure", value: "stagnant", note: "Built for a different era" },
  ];

  return (
    <SlideFrame tag="01 · The Case">
      <div className="max-w-6xl">
        <p className="overline mb-6">Market reality</p>
        <h2 className="font-display text-5xl md:text-6xl tracking-tighter leading-[0.95] font-medium max-w-4xl">
          Modern lending is scaling faster than the infrastructure <em className="italic">beneath it</em>.
        </h2>

        <div className="mt-14 border-t border-foreground/20">
          {data.map((row, i) => (
            <div key={i} className="grid grid-cols-12 gap-4 py-6 border-b border-foreground/20 items-baseline">
              <span className="col-span-1 font-mono-data text-xs text-muted-foreground">{String(i + 1).padStart(2, "0")}</span>
              <span className="col-span-6 md:col-span-5 font-display text-2xl md:text-3xl">{row.label}</span>
              <span className={`col-span-5 md:col-span-3 font-mono-data text-sm uppercase tracking-brand ${row.value === "stagnant" ? "text-primary" : "text-foreground"}`}>
                {row.value}
              </span>
              <span className="hidden md:inline col-span-3 text-sm text-muted-foreground">{row.note}</span>
            </div>
          ))}
        </div>

        <p className="mt-10 font-display text-2xl italic text-foreground/80 max-w-3xl">
          What happens <span className="not-italic text-primary font-medium">after</span> funding is now the bottleneck.
        </p>
      </div>
    </SlideFrame>
  );
}
